import React from 'react';
import { UnirendHead } from '../internal/UnirendHead';

export interface DefaultNotFoundProps {
  /** The error object from React Router */
  error?: unknown;
}

/**
 * Default 404 Not Found component with clean, unbranded styling
 */
export default function DefaultNotFound({
  error: _error,
}: DefaultNotFoundProps) {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'system-ui, Arial, sans-serif',
        background: '#f7f7f8',
      }}
    >
      <UnirendHead>
        <title>404 - Page Not Found</title>
      </UnirendHead>
      <main
        style={{
          background: '#fff',
          borderRadius: '14px',
          boxShadow: '0 2px 16px rgba(0,0,0,0.08)',
          maxWidth: '440px',
          width: '100%',
          margin: '32px',
          padding: '32px 28px 24px 28px',
          textAlign: 'center',
          boxSizing: 'content-box',
        }}
      >
        <div
          style={{
            color: '#e53935',
            fontSize: '2rem',
            fontWeight: '600',
            marginBottom: '12px',
            letterSpacing: '0.01em',
          }}
        >
          404 - Page Not Found
        </div>

        <div
          style={{
            fontSize: '1.1rem',
            fontWeight: '500',
            marginBottom: '24px',
            color: '#222',
          }}
        >
          The page you're looking for doesn't exist.
        </div>

        <div
          style={{
            background: '#f1f1f3',
            borderRadius: '6px',
            padding: '12px 14px',
            fontSize: '0.98rem',
            color: '#222',
            marginBottom: '18px',
          }}
        >
          The requested page could not be found or has been moved to a different
          location.
        </div>

        <button
          onClick={() => window.history.back()}
          type="button"
          style={{
            margin: '18px auto 0 auto',
            display: 'block',
            background: '#2563eb',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            padding: '10px 22px',
            fontSize: '1rem',
            fontWeight: '500',
            cursor: 'pointer',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            transition: 'background 0.15s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#1d4ed8';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#2563eb';
          }}
        >
          Go Back
        </button>
      </main>
    </div>
  );
}
